import BusinessShowcase from '../components/sections/BusinessShowcase/BusinessShowcase'

function VenturesPage() {
  return (
    <>
      <BusinessShowcase />
    </>
  )
}

export default VenturesPage
